<!--
   千人画师征集活动报名成功页面
-->
<template>
  <div class="success-page">
    <div class="success-content">
      <div class="">
        <DuIcon name="check-heavy" size='12.8rem' />
      </div>
      <div class="success-title">报名成功</div>
      <!-- <div class="success-desc">
        请留意中选通知，届时请按要求发布抽选
      </div> -->
    </div>

    <div class="success-footer">
      <van-button class="back-btn" block @click="handleBack"> 返回 </van-button>
    </div>
  </div>
</template>

<script setup>
import { DuIcon } from "dangoui";
import { Icon as VanIcon, Button as VanButton } from "vant";
import { isLinjieApp } from "@/utils/env-related";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import jb from "@frontend/effuse";

const handleBack = () => {
  if (isLinjieApp()) {
    jb.navigateBack();
  } else {
    window.history.back();
  }
};
</script>

<style lang="scss" scoped>
.success-page {
  min-height: 100vh;
  background-color: #fff;
  display: flex;
  flex-direction: column;

  .success-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 48rpx;

    .success-icon {
      width: 128rpx;
      height: 128rpx;
      border-radius: 50%;
      background: linear-gradient(180deg, #2b1ac0 0%, #7247dc 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 32rpx;

      :deep(.van-icon) {
        font-size: 64rpx;
        color: #fff;
      }
    }

    .success-title {
      font-size: 36rpx;
      font-weight: 600;
      color: #000;
      margin-bottom: 16rpx;
    }

    .success-desc {
      font-size: 28rpx;
      color: rgba(0, 0, 0, 0.6);
      text-align: center;
      line-height: 40rpx;
    }
  }

  .success-footer {
    padding: 16rpx 20rpx;
    padding-bottom: calc(16rpx + env(safe-area-inset-bottom));

    .back-btn {
      height: 96rpx;
      background: linear-gradient(180deg, #2b1ac0 0%, #7247dc 100%);
      border-radius: 12rpx;
      border: none;
      font-size: 32rpx;
      font-weight: 500;
      color: #fff;
    }
  }
}
</style>
